import { render, staticRenderFns } from "./RChartHeatmap.vue?vue&type=template&id=0a7b6544&"
import script from "./RChartHeatmap.vue?vue&type=script&lang=js&"
export * from "./RChartHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports